namespace('compass.hotel');

compass.hotel.PoliciesWidget = compass.defineWidget(function PoliciesWidget(options) {
	var me = this;
	var $j = jQuery;

	var _settings = options;

	var _policies = $j.isArray(_settings.policies.policies) ? _settings.policies.policies :
		[_settings.policies.policies];

	_validator = null;

	this.validate = function() {
		this.validator.validateAll();
		return this.validator.valid;
	};

	var _setupControls = this.setupControls = function() {

	};

	var _render = this.render = function(widgetElem) {

		var d = _d;
		var holderDiv = d.div({className:'policiesDiv'});
		holderDiv.append(
			me.drawPolicyHeader()
		);

		for (var i=0; i < _policies.length; i++) {
			holderDiv.append(
				me.drawHotelAndRoomNameHeader(i)
			);

			if(_policies[i].depositPolicy.length > 0) {
				holderDiv.append(
					me.drawDepositPolicyHeader(),
					me.drawDepositPolicy(i)
				);
			}

			if(_policies[i].cancelPolicy.length > 0) {
				holderDiv.append(
					me.drawCancelPolicyHeader(),
					me.drawCancelPolicy(i)
				);
			}


			if(_policies[i].changesPolicy.length > 0) {
				holderDiv.append(
					me.drawChangesPolicyHeader(),
					me.drawChangesPolicy(i)
				);
			}

			if(_policies[i].specialPolicy.length > 0) {
				holderDiv.append(
					me.drawSpecialPolicyHeader(),
					me.drawSpecialPolicy(i)
				);
			}
		}

		widgetElem.append(holderDiv);
		_setupControls();
	};

	this.drawPolicyHeader = function() {
		var d = _d;
		return d.div({className:'policyHeader'},
			d.h3({className:'policyHeaderText'}, 'Policies'));
	};

	this.drawHotelAndRoomNameHeader = function(i) {
		var d = _d;
		return d.div({className: 'hotelAndRoomNameHeader'},
			d.div({className:'policyHeader'},
				d.div({className:'policyHotelName'}, _policies[i].hotelName)
			),
			d.div({className:'policyHeader'},
				d.div({className:'policyRoomName'}, _policies[i].roomName)
			)
		);
	};

	this.drawDepositPolicyHeader = function() {
		var d = _d;
		return d.div({
			className : 'policyHeader depositPolicyHeader'
		}, 'Deposit Policy');
	};

	this.drawDepositPolicy = function(i) {
		var d = _d;
		return d.div({
			className : 'policyText depositPolicy'
		}, _policies[i].depositPolicy);
	};


	this.drawCancelPolicyHeader = function() {
		var d = _d;
		return d.div({
			className : 'policyHeader cancelPolicyHeader'
		}, 'Cancellation Policy');
	};

	this.drawCancelPolicy = function(i) {
		var d = _d;
		return d.div({
			className : 'policyText cancelPolicy'
		}, _policies[i].cancelPolicy);
	};


	this.drawChangesPolicyHeader = function() {
		var d = _d;
		return d.div({
			className : 'policyHeader changesPolicyHeader'
		}, 'Changes Policy');
	};

	this.drawChangesPolicy = function(i) {
		var d = _d;
		return d.div({
			className : 'policyText changesPolicy'
		}, _policies[i].changesPolicy);
	};

	this.drawSpecialPolicyHeader = function() {
		var d = _d;
		return d.div({
			className : 'policyHeader specialPolicyHeader'
		}, 'Special Policy');
	};

	this.drawSpecialPolicy = function(i) {
		var d = _d;
		return d.div({
			className : 'policyText specialPolicy'
		}, _policies[i].specialPolicy);
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'PoliciesWidget',
	imgPath : '/resources/img',
	subclass : false,
	policies : { }
});

